import type { QueryFunctionContext } from "@tanstack/react-query"
import api from "../api"

export type QueryFnArgs = {
  context?: QueryFunctionContext
  url: string
  method?: string
  route: string
  urlSearchParams?: Record<string, unknown>
  ttl?: number
  cacheId?: string
  dataKey?: string
  metaKey?: string
  onSuccess?: (data: any) => void
  onError?: (err: any) => void
  includeProfileId?: boolean
}

async function queryFn({
  url,
  method = "get",
  route,
  urlSearchParams = {},
  ttl = 0,
  cacheId,
  includeProfileId,
}: QueryFnArgs) {
  const options: any = {
    url: `${route}/${url}`,
    method,
    params: urlSearchParams,
    cache: {
      ttl: 1000 * 60 * ttl,
    },
  }
  if (includeProfileId !== undefined) options.includeProfileId = includeProfileId
  if (cacheId) options.id = cacheId

  const response = await api(options)

  return response
}

export default queryFn
